import { createContext, useContext, useEffect, useState } from 'react';

import { load } from '@fingerprintjs/fingerprintjs';

const FPContext = createContext();

export const FPProvider = ({ children }) => {

  const [ fp, setFP ] = useState();

  useEffect(() => {

    load()
      .then(fp => setFP(fp))
      .catch(err => setFP(null));

  }, []);

  const context = { fp };

  return (
    <FPContext.Provider value={context}>
      {children}
    </FPContext.Provider>
  );
};

export const useFPContext = () => useContext(FPContext);